<template>
    <el-row class="main-box" ref="container">
        <el-col>
            <el-row>
                <el-col :sm="{ span: 23, offset: 1 }" :md="{ span: 23, offset: 1 }" :lg="{ span: 22, offset: 2 }">
                    <el-image class="main-box-bg"
                        src="https://language-training.oss-cn-hangzhou.aliyuncs.com/frontImage/image1.jpg" fit="cover"
                        :lazy="true"></el-image>
                    <el-row>
                        <el-col :xs="{ span: 24, offset: 0 }">
                            <div class="title-box">
                                <div class="title-box-text1">简易读语言艺术训练系统</div>
                                <div class="title-box-tipsbox flex-row f-center">
                                    三天让孩子学会与世界沟通
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>

            <el-row>
                <el-col :sm="{ span: 24, offset: 0 }" :md="{ span: 24, offset: 0 }" :lg="{ span: 22, offset: 1 }"
                    :xl="{ span: 20, offset: 2 }">
                    <el-row class="flex-row">
                        <el-col :sm="{ span: 12, offset: 0 }" :md="{ span: 9, offset: 0 }" :lg="{ span: 8, offset: 0 }"
                            :xl="{ span: 6, offset: 0 }">
                            <el-row>
                                <el-col class="flex-row " :sm="{ span: 24, offset: 0 }" :md="{ span: 24, offset: 0 }"
                                    :lg="{ span: 24, offset: 0 }">
                                    <div class="aside-box flex-colmn">
                                        <aside class="info-box flex-column">
                                            <div class="info-box-user flex-row flex-wrap f-center">
                                                <el-image  class="info-box-user-img"
                                                    :src="getuserheadurl()" fit="contain" :lazy="true"></el-image>
                                                <div class="info-box-user-right flex-column">
                                                    <div class="info-box-user-right-name">
                                                        {{ userInfos.userName }}
                                                    </div>
                                                    <div v-if="userInfos.role == 0" class="flex-row flex-wrap"
                                                        style="margin-top:14px;">
                                                        <div class="info-box-user-right-text1">剩余课时</div>
                                                        <div class="flex-colmun">
                                                            <div class="info-box-user-right-text2">
                                                                {{ userInfos.classHour60 ? '60分钟的课时剩余 ' +
                                                                    userInfos.classHour60
                                                                    + '次' : '60分钟的课时剩余 0 次' }}</div>
                                                            <div class="info-box-user-right-text2">
                                                                {{ userInfos.classHour30 ? '30分钟的课时剩余 ' +
                                                                    userInfos.classHour30
                                                                    + '次' : '30分钟的课时剩余 0 次' }}</div>
                                                        </div>
                                                    </div>
                                                    <div v-else-if="userInfos.role == 1"
                                                        class="flex-row f-align-center flex-wrap" style="margin-top:14px;">
                                                        <div class="info-box-user-right-text1 info-box-user-right-text3">
                                                            教学绩效值</div>
                                                        <div class="start-level-box flex-row">
                                                            <img v-for="(item, index) in getStartLevel(userInfos.performance)"
                                                                :key="'start_level' + index" :src="item" alt="">
                                                        </div>
                                                    </div>
                                                    <div class="flex-row flex-wrap" style="margin-top:5px;">
                                                        <div class="info-box-user-right-text1 info-box-user-right-text3">
                                                            我的推荐码</div>
                                                        <div class="info-box-user-right-text2">{{ userInfos.loginName }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </aside>

                                        <aside class="tips-box flex-column">
                                            <div class="tips-box-info flex-column f-center">
                                                <div class="tips-box-text" style="padding:20px 19px 0 25px">
                                                    {{ WordsSentence.word }}
                                                </div>
                                                <div class="tips-box-text2" style="padding:14px 19px 26px 25px">
                                                    {{ WordsSentence.chinese }}
                                                </div>
                                            </div>
                                        </aside>
                                        <aside class="edu-list-box flex-column">
                                            <div class="edu-list-box-info flex-column f-center">

                                                <template v-if="userInfos.role == 0">

                                                    <el-image v-if="planCourseList.length == 0"
                                                        class="edu-list-box-info-img"
                                                        :src="require('@/static/class-bg.png')" fit="fill "
                                                        :lazy="true"></el-image>
                                                    <div v-else class="edu-list-box-info-list flex-column flex1">
                                                        <div class="edu-list-box-info-list-title flex-row f-align-center">
                                                            <img src="../static/notepad_badge.png" alt="">
                                                            <span>课程安排</span>
                                                        </div>
                                                        <div class="edu-list-box-classlist flex-column">
                                                            <div v-for="(item, index) in planCourseList"
                                                                :key="'class_item' + index"
                                                                class="edu-list-box-classitem flex-row f-align-center f-justify-between"
                                                                :class="item.status == 2||item.status == 3 ? 'edu-list-box-classitem-grey' : ''">
                                                                <div class="edu-list-box-classitem-left flex-column">
                                                                    <span>{{ item.courseName }}</span>
                                                                    <span>{{ item.teacherName }} {{ item.classTime }}</span>
                                                                </div>
																	
																<div v-if="item.status == 3" style="margin-right: 18px; color: #ccc;" class="f-justify-end">
																		已取消
																</div>	
                                                            </div>
                                                        </div>
                                                    </div>
                                                </template>

                                                <template v-else>
                                                    <div class="edu-list-box-info-list flex-column flex1">
                                                        <div class="edu-list-box-info-list-title flex-row f-align-center">
                                                            <img src="../static/notepad_badge.png" alt="">
                                                            <span>课程安排</span>
                                                        </div>
                                                        <div class="calendar-box flex-colmun">
                                                            <el-calendar v-model="calendarValue" :range="calendarRange"
                                                                :first-day-of-week="7">

                                                                <template slot="dateCell" slot-scope="{date, data}">
                                                                    <div
                                                                        :class="[data.isSelected ? 'is-selected' : '', getCurrentDayHasClass(data.day) ? 'has_class' : '']">
                                                                        {{ getFormateDays(data.day) }}日 {{
                                                                            data.isSelected ? '' : '' }}
                                                                    </div>
                                                                </template>

                                                            </el-calendar>
                                                        </div>
                                                        <div class="edu-list-box-classlist flex-column">
                                                            <template v-if="planCourseList.length > 0">
                                                                <div v-for="(item, index) in planCourseList"
                                                                    :key="'class_item' + index"
                                                                    class="edu-list-box-classitem flex-row f-align-center f-justify-between"
                                                                    :class="item.status == 2||item.status == 3 ? 'edu-list-box-classitem-grey' : ''">
                                                                    <div class="edu-list-box-classitem-left flex-column">
																		<div style="display: flow;">
																			<span 
																			 v-if="item.classType==0"
																			style="margin-top: 0;
																			padding-left: 4px;
																			padding-right: 4px;
																			height: 18px;
																			border-radius: 4px;
																			background: #FFA011;
																			line-height: 18px;
																			text-align: center;
																			margin-right: 2px;
																			color: #FFFFFF;
																			font-size: 14px;">体验</span>
																			<span style="margin: 0;
																			font-family: Source Han Sans;
																			font-size: 18px;
																			font-weight: bold;
																			line-height: 19px;
																			align-items: center;
																			letter-spacing: 0em;
																			color: #333333;
																			">{{item.courseName }}</span>
																		</div>
                                                                        <span>{{ item.studentName }} {{
                                                                            item.classTime }}</span>
                                                                    </div>
                                                                    <div v-if="item.status != 2&&item.status != 3">
																		<div    @click="startClassHandle(item.id, item.courseId, item.studentId, item.courseName, item.studentName,item.classType,item.courseType)"
																			class="edu-list-box-classitem-btn">
																			上课
																		</div>
																		
                                                                        <div    @click="startClassHandle2(item.id)"
                                                                        	class="edu-list-box-classitem-btn2">
                                                                        	取消
                                                                        </div>
                                                                    </div>
																	<div v-else-if="item.status == 3" style="margin-right: 18px; color: #ccc;" class="f-justify-end">
																		已取消
																	</div>
                                                                </div>
                                                            </template>
                                                            <template v-else>
                                                                <div class="flex-column flex1 f-center">
                                                                    <img class="class-no-data"
                                                                        src="../static/saleClass-nodata.png" alt="">
                                                                    <span class="class-no-data-text">暂无课程安排~</span>
                                                                </div>
                                                            </template>
                                                        </div>
                                                    </div>
                                                </template>


                                            </div>

                                            <div v-if="userInfos.role == 1" class="edu-list-box-data flex-column">
                                                <div class="edu-list-box-data-title flex-row f-align-center">
                                                    <img src="../static/statistics-badge.png" alt="">
                                                    <span>销量统计</span>
                                                </div>
                                                <div class="edu-list-box-data-content flex-column">
                                                    <div v-for="(item, index) in eduDataList" :key="'data_item' + index"
                                                        class="edu-list-box-data-content-item flex-row  f-align-center">
                                                        <span style="white-space:nowrap;">{{ item.name }}</span>
                                                        <div class="flex-row f-align-center" style="white-space:nowrap;">
                                                            <numer-split v-if="salesStatistic"
                                                                :val="salesStatistic[item.val]"
                                                                class="edu-list-box-data-content-item-num"></numer-split>
                                                            <span class="edu-list-box-data-content-item-rate">{{
                                                                item.rate }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </aside>
                                    </div>
                                </el-col>
                            </el-row>
                        </el-col>

                        <el-col class="flex-column" :sm="{ span: 12, offset: 0 }" :md="{ span: 15, offset: 0 }"
                            :lg="{ span: 16, offset: 0 }" :xl="{ span: 18, offset: 0 }">
                            <div v-if="userInfos.role == 1" class="avatar-box flex-row flex-wrap">
                                <div v-if="isshowex==1||index<18" v-for="(item, index) in studentList" :key="'avatar_item' + index"
                                    class="avatar-box-item flex-column flex-align-center">
                                    <el-image class="avatar-box-item-img" :src="getuserheadurlitem(item.avatar,item.userSex)"  fit="fill"
                                        :lazy="true"></el-image>
                                    <span class="avatar-box-item-name">{{ item.userName }}</span>
                                </div>
                                <div v-if="studentList.length > 18" @click="moreHandle"
                                    class="avatar-box-item flex-column flex-align-center">
                                    <el-image class="avatar-box-item-img avatar-box-item-img2"
                                        :src="require('@/static/more-badge.png')" fit="fill" :lazy="true"></el-image>
                                    <span class="avatar-box-item-text">{{ studentList.length }}人</span>
                                </div>
                            </div>

                            <article class="content-box flex-column flex1">
                                <div class="content-box-head flex-row f-align-center">
                                    <img src="../static/book.png" alt="">
                                    <span>销课记录</span>
                                </div>
                                <template v-if="classSalesRecordList.length > 0">
                                    <div class="list-box flex-column">
                                        <div v-for="(item, index) in classSalesRecordList" :key="'list' + index"
                                            class="list-box-item flex-row  f-align-center flex1 f-justify-between">
                                            <div class="list-box-item-left flex-row f-align-center">
                                                <img class="list-box-item-badge" src="../static/class-badge.png" alt="">
                                                <div class="list-box-item-infobox flex-column ">
                                                    <div
                                                        class="list-box-item-infobox-tipsbox flex-row flex-wrap f-align-center">
                                                        <span class="list-box-item-text1">{{ item.courseName }}</span>
                                                        <span class="list-box-item-text2"> 课程学习单词: {{ item.totalWordCount
                                                        }}</span>
                                                    </div>
                                                    <div
                                                        class="list-box-item-infobox-bottom flex-row f-align-center flex-wrap">
                                                        <span class="list-box-item-text3 marginRight13">{{ userInfos.role ==
                                                            0 ? item.teacherName : item.studentName
                                                        }}</span>
                                                        <span class="list-box-item-text3 ">{{ item.classTime }}</span>
                                                    </div>

                                                </div>
                                            </div>
                                            <div class="list-box-btnbox flex-row  flex1 f-justify-end"
                                                style=" flex-shrink: 0;">
                                                <div class="flex-row " style="margin:10px 0;">

                                                    <div v-if="item.totalWordCount&&item.totalWordCount>0"  class="list-box-btn1 flex-column f-center"
                                                        @click="classrecod(item.id, item.courseId,item.courseType)">
                                                        课程记录
                                                    </div>
                                                    <template v-if="userInfos.role == 1">
                                                        <div v-if="item.status == 0" @click="classAppraise(item, index)"
                                                            class="list-box-btn2 flex-column f-center">课程评价</div>
                                                        <div v-else @click="queryLookAppraise(item)"
                                                            class="list-box-btn3 flex-column f-center">已评价</div>
                                                    </template>
                                                    <template v-if="userInfos.role == 0">
                                                        <div v-if="item.status == 1" @click="queryLookAppraise(item)"
                                                            class="list-box-btn3 flex-column f-center">已评价</div>
                                                        <div v-else @click="queryLookAppraise(item)"
                                                            class="list-box-btn3 flex-column f-center">等待评价中</div>
                                                    </template>
                                                </div>
                                                <div v-if="item.totalWordCount&&item.totalWordCount>0" class="list-box-btn4 flex-column f-center" @click="print(item.id,item.courseType)">
                                                    <img src="../static/print-badge.png" alt="">
                                                    <span>打印</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="page-contorlbox flex-row f-justify-center">
                                        <div @click="prePageClassSaleRecord"
                                            :class="pageNum == 1 ? 'page-controlbox-btn-disabled' : ''"
                                            class="page-controlbox-btn">上一页</div>
                                        <div @click="nextPageClassSaleRecord"
                                            :class="classSalesTotal == classSalesRecordList.length ? 'page-controlbox-btn-disabled' : ''"
                                            class="page-controlbox-btn">下一页</div>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="flex-column flex1 f-align-center">
                                        <img class="no-data" src="../static/saleClass-nodata.png" alt="">
                                        <span>暂无课程记录，赶快上课吧</span>
                                    </div>
                                </template>
                            </article>
                        </el-col>

                    </el-row>
                </el-col>
            </el-row>

        </el-col>


        <el-dialog title="" :center="true" :visible.sync="dialogAppraise" :show-close="false"
            @closed="dialogAppraiseClosed">
            <el-row slot="title" style="width: 100%;">
                <el-col :xs="{ span: 22, offset: 1 }" :sm="{ span: 22, offset: 1 }" :md="{ span: 21, offset: 1 }" :lg="{ span: 18, offset: 3 }">
                    <div class="appraise-popup-title flex-row f-justify-between f-align-center">
                        <div style="width:56px;height:56px;"></div>
                        <span class="appraise-popup-title-name">课程评价</span>
                        <img @click="dialogAppraise = false" src="../static/close.png" alt="">
                    </div>

                </el-col>
            </el-row>
            <el-row style="width: 100%;">
                <el-col :xs="{ span: 22, offset: 1 }" :sm="{ span: 22, offset: 1 }" :md="{ span: 22, offset: 1 }" :lg="{ span: 18, offset: 3 }">
                    <div v-if="slectedAppraise" class="appraise-popup-content flex-column f-align-center">
						<img   src="../static/jyd_bg_ic.png" style="width: 775px;height: 348px; position: absolute;top: 0;">
						
                        <div class="appraise-popup-content-title flex-cloumn f-align-center">
                            <div class="textcls f-align-center" style="text-align: center;">
								{{dateFormateStr(slectedAppraise.classTime, "YYYY-MM-DD hh:mm") }}
                            </div>
							<div class="textcls flex-row f-justify-center" style="margin-top: 14px;">
								<div class="flex-row f-align-center flex1 f-justify-end">
								    <span>教练：</span>
								    <span style="color: #0AA26B;">{{ slectedAppraise.teacherName }}</span>
								</div>
								<div style="width: 50px;"></div>
								<div class="flex-row f-align-center flex1" >
								    <span>学员：</span>
								    <span  style="color: #0AA26B;">{{ slectedAppraise.studentName }}</span>
								</div>
							</div>
							
							<div class="textcls flex-row f-justify-center" style="margin-top: 14px;">
								<div class="flex-row f-align-center flex1 f-justify-end">
								    <span>学时：</span>
								    <span style="color: #0AA26B;">{{ getClassTypeStr(slectedAppraise.classType) }}分钟</span>
								</div>
								<div style="width: 50px;"></div>
								<div class="flex-row f-align-center flex1" >
								    <span>课程识词：</span>
								    <span  style="color: #0AA26B;">{{ slectedAppraise.totalWordCount }}</span>
								</div>
							</div>
							<div class="textcls flex-row f-justify-center" style="margin-top: 14px;">
								<div class="flex-row f-align-center flex1 f-justify-end">
								    <span>剩余60分钟课时：</span>
								    <span style="color: #0AA26B;">{{ slectedAppraise.classHour60 }}课时</span>
								</div>
								<div style="width: 50px;"></div>
								<div class="flex-row f-align-center flex1" >
								    <span>累计60分钟课时：</span>
								    <span  style="color: #0AA26B;">{{ slectedAppraise.totalClassHour60 }}课时</span>
								</div>
							</div>
							
							<div class="textcls flex-row f-justify-center" style="margin-top: 14px;">
								<div class="flex-row f-align-center flex1 f-justify-end">
								    <span>剩余30分钟课时：</span>
								    <span style="color: #0AA26B;">{{ slectedAppraise.classHour30 }}课时</span>
								</div>
								<div style="width: 50px;"></div>
								<div class="flex-row f-align-center flex1" >
								    <span>累计30分钟课时：</span>
								    <span  style="color: #0AA26B;">{{ slectedAppraise.totalClassHour30 }}课时</span>
								</div>
							</div>
                        </div>
						
						
                        <div class="appraise-popup-content-level flex-row flex-wrap f-align-center">
                            <div class="appraise-popup-content-level-name">
                                教练评星
                                <div class="appraise-popup-content-level-badge">
                                </div>
                            </div>
                            <div class="appraise-popup-content-startbox flex-row f-align-center">
                                <img @click="changeStartNumer(index)" v-for="(item, index) in 5" :key="'start' + index"
                                    :src="startNumerIndex > index ? require('@/static/start-dark.png') : require('@/static/start-light.png')"
                                    alt="">
                            </div>
                            <div v-if="startNumerIndexRquire" class="appraise-popup-content-level-require flex-row flex1">
                                <span>请给教师评星</span>
                            </div>
                        </div>

                        <div class="appraise-popup-content-textbox flex-row flex-wrap">
                            <div class="appraise-popup-content-level-name">
                                教练评价
                                <div class="appraise-popup-content-level-badge">
                                </div>
                            </div>
                            <el-input class="appraise-popup-content-textbox-input" type="textarea" maxlength="200"
                                :autosize="{ minRows: 8, maxRows: 8 }" placeholder="请输入内容" v-model="appraiseText">
                            </el-input>
                        </div>
                        <div v-if="appraiseTextRquire" class="appraise-popup-content-level-require flex-row flex1">
                            <span>请输入评价</span>
                        </div>
                        <div class="appraise-popup-footer flex-row f-justify-end">
                            <div @click="dialogAppraise = false" class="appraise-popup-footer-btn1">返回</div>
                            <div @click="appraiseSubmit" class="appraise-popup-footer-btn2">提交</div>
                        </div>
                    </div>

                </el-col>
            </el-row>

        </el-dialog>

        <el-dialog title="" :center="true" :visible.sync="dialogLookAppraise" :show-close="false" @open="lookAppraiseOpen"
            @closed="lookAppraiseClosed">

            <el-row slot="title" style="width: 100%;">
               <el-col :xs="{ span: 22, offset: 1 }" :sm="{ span: 22, offset: 1 }" :md="{ span: 22, offset: 1 }" :lg="{ span: 18, offset: 3 }">
                    <div class="appraise-popup-title flex-row f-justify-between f-align-center">
                        <div style="width:56px;height:56px;"></div>
                        <span class="appraise-popup-title-name">查看评价</span>
                        <img @click="dialogLookAppraise = false" src="../static/close.png" alt="">
                    </div>

                </el-col>
            </el-row>
            <el-row style="width: 100%;">
               <el-col :xs="{ span: 22, offset: 1 }" :sm="{ span: 22, offset: 1 }" :md="{ span: 22, offset: 1 }" :lg="{ span: 18, offset: 3 }">
                    <div v-if="appraiseInfo" class="appraise-popup-content flex-column f-align-center">
                    <img   src="../static/jyd_bg_ic.png" style="width: 775px;height: 348px; position: absolute;top: 0;">
                    
                    <div class="appraise-popup-content-title flex-cloumn f-align-center">
                        <div class="textcls f-align-center" style="text-align: center;">
                    		{{dateFormateStr(slectedAppraise.classTime, "YYYY-MM-DD hh:mm") }}
                        </div>
                    	<div class="textcls flex-row f-justify-center" style="margin-top: 14px;">
                    		<div class="flex-row f-align-center flex1 f-justify-end">
                    		    <span>教练：</span>
                    		    <span style="color: #0AA26B;">{{ slectedAppraise.teacherName }}</span>
                    		</div>
                    		<div style="width: 50px;"></div>
                    		<div class="flex-row f-align-center flex1" >
                    		    <span>学员：</span>
                    		    <span  style="color: #0AA26B;">{{ slectedAppraise.studentName }}</span>
                    		</div>
                    	</div>
                    	
                    	<div class="textcls flex-row f-justify-center" style="margin-top: 14px;">
                    		<div class="flex-row f-align-center flex1 f-justify-end">
                    		    <span>学时：</span>
                    		    <span style="color: #0AA26B;">{{ getClassTypeStr(slectedAppraise.classType) }}分钟</span>
                    		</div>
                    		<div style="width: 50px;"></div>
                    		<div class="flex-row f-align-center flex1" >
                    		    <span>课程识词：</span>
                    		    <span  style="color: #0AA26B;">{{ slectedAppraise.totalWordCount }}</span>
                    		</div>
                    	</div>
                    	<div class="textcls flex-row f-justify-center" style="margin-top: 14px;">
                    		<div class="flex-row f-align-center flex1 f-justify-end">
                    		    <span>剩余60分钟课时：</span>
                    		    <span style="color: #0AA26B;">{{ slectedAppraise.classHour60  }}课时</span>
                    		</div>
                    		<div style="width: 50px;"></div>
                    		<div class="flex-row f-align-center flex1" >
                    		    <span>累计60分钟课时：</span>
                    		    <span  style="color: #0AA26B;">{{ slectedAppraise.totalClassHour60 }}课时</span>
                    		</div>
                    	</div>
                    	
                    	<div class="textcls flex-row f-justify-center" style="margin-top: 14px;">
                    		<div class="flex-row f-align-center flex1 f-justify-end">
                    		    <span>剩余30分钟课时：</span>
                    		    <span style="color: #0AA26B;">{{ slectedAppraise.classHour30c }}课时</span>
                    		</div>
                    		<div style="width: 50px;"></div>
                    		<div class="flex-row f-align-center flex1" >
                    		    <span>累计30分钟课时：</span>
                    		    <span  style="color: #0AA26B;">{{ slectedAppraise.totalClassHour30 }}课时</span>
                    		</div>
                    	</div>
                    </div>
					
                        <div class="appraise-popup-content-level flex-row flex-wrap f-align-center">
                            <div class="appraise-popup-content-level-name">
                                教练评星
                            </div>
                            <div class="appraise-popup-content-startbox flex-row f-align-center">
                                <img @click="changeStartNumer(index)" v-for="(item, index) in 5" :key="'start' + index"
                                    :src="appraiseInfo.teacherStar > index ? require('@/static/start-dark.png') : require('@/static/start-light.png')"
                                    alt="">
                            </div>
                        </div>
                        <div class="appraise-popup-content-textbox flex-row flex-wrap">
                            <div class="appraise-popup-content-level-name">
                                教练评价
                            </div>
                            <div class="appraise-popup-content-textbox-text">{{appraiseInfo.teacherEvaluate}}
                            </div>
                        </div>
                        <div class="appraise-popup-content-textbox flex-row flex-wrap" style="margin-top:18px;">
                            <div class="appraise-popup-content-level-name" >
                                今日遗忘的单词
                            </div>
                            <div class="appraise-popup-content-textbox-word flex-row flex-wrap">
                                <template v-if="appraiseInfo.amnesicWords">
                                    <div v-for="(childItem, index) in appraiseInfo.amnesicWords" :key="'woed' + index"
                                        class="appraise-popup-content-textbox-word-item flex-row f-align-center">
                                        <span class="appraise-popup-content-textbox-word-left">{{ childItem.word }}</span>
                                        <span class="appraise-popup-content-textbox-word-right">{{ childItem.chinese
                                        }}</span>
                                    </div>
                                </template>
                                <div v-else style="width:10%;font-size:16px;margin-top:10px;">无</div>
                            </div>
                        </div>
                        <div class="appraise-popup-content-line"></div>
                        <div class="appraise-popup-footer flex-row f-justify-end">
                            <div @click="dialogLookAppraise = false" class="appraise-popup-footer-btn1">返回</div>
                        </div>
                    </div>

                </el-col>
            </el-row>

        </el-dialog>



        <el-dialog title="" :center="true" :visible.sync="dialogConfrimStartClass" :show-close="false">
            <el-row slot="title" style="width: 100%;">
                <el-col :xs="{ span: 22, offset: 1 }" :sm="{ span: 22, offset: 1 }" :md="{ span: 24, offset: 0 }">
                    <div class="appraise-popup-title flex-row f-justify-between f-align-center">
                        <div style="width:56px;height:56px;"></div>
                        <span class="appraise-popup-title-name">提示</span>
                        <img @click="dialogConfrimStartClass = false" src="../static/close.png" alt="">
                    </div>

                </el-col>
            </el-row>
            <el-row style="width: 100%;">
                <el-col :xs="{ span: 22, offset: 1 }" :sm="{ span: 22, offset: 1 }" :md="{ span: 24, offset: 0 }">
                    <div class="start-popup-content flex-column f-align-center">
                        <div class="start-popup-content-tipsbox flex-row f-align-center">
                            <span>确认开始学员 <span style="color:#0AA26B;"> {{ tClassname }}</span> 的课程吗</span>
                        </div>
                        <div class="start-popup-content-line"></div>
                        <div class="start-popup-content-btnsbox flex-row f-justify-end" style="width:100%;">
                            <div style="cursor: pointer;" @click="dialogConfrimStartClass = false">返回</div>
                            <div style="cursor: pointer;" @click="startSubmit">开始</div>
                        </div>
                    </div>

                </el-col>
            </el-row>
        </el-dialog>
		
		
		
		<el-dialog title="" :center="true" :visible.sync="dialogAppraise2" :show-close="false"
		    @closed="dialogAppraiseClosed">
		    <el-row slot="title" style="width: 100%;">
		        <el-col :xs="{ span: 22, offset: 1 }" :sm="{ span: 22, offset: 1 }" :md="{ span: 24, offset: 0 }">
		            <div class="appraise-popup-title flex-row f-justify-between f-align-center">
		                <div style="width:56px;height:56px;"></div>
		                <span class="appraise-popup-title-name">申请取消</span>
		                <img @click="dialogAppraise2 = false" src="../static/close.png" alt="">
		            </div>
		
		        </el-col>
		    </el-row>
		    <el-row style="width: 100%;">
		        <el-col :xs="{ span: 22, offset: 1 }" :sm="{ span: 22, offset: 1 }" :md="{ span: 24, offset: 0 }">
		            <div class="appraise-popup-content2 flex-column f-align-center">
		
						<div class="appraise-popup-content-textbox flex-row flex-wrap">
							<div class="appraise-popup-content-level-name">
								申请角色
								<div class="appraise-popup-content-level-badge">
								</div>
							</div>
							<el-select class="content-box2-select"   v-model="courseName" placeholder="请选择">
								<!-- /** 申请角色  学生、教练 0 学员 1 教练 */ -->
							    <el-option  key="0" label="学生" value="学生">
							    </el-option>
								<el-option  key="1" label="教练" value="教练">
								</el-option>
							</el-select>
						</div>
		                <div class="appraise-popup-content-textbox flex-row ">
		                    <div class="appraise-popup-content-level-name">
		                        申请原因
		                        <div class="appraise-popup-content-level-badge">
		                        </div>
		                    </div>
		                    <el-input class="appraise-popup-content-textbox-input1 flex1" type="textarea" maxlength="200"
		                        :autosize="{ minRows: 8, maxRows: 8 }" placeholder="请输入内容" v-model="appraiseText2">
		                    </el-input>
		                </div>
		                <div class="appraise-popup-footer flex-row f-justify-end">
		                    <div @click="dialogAppraise2 = false" class="appraise-popup-footer-btn1">返回</div>
		                    <div @click="cancelPlanApply()" class="appraise-popup-footer-btn2">提交</div>
		                </div>
		            </div>
		
		        </el-col>
		    </el-row>
		
		</el-dialog>
		
		
		<div v-if="cwheight>10" class="cwdivcls flex-column f-align-center">
			<div class="cwdivlinecls"  :style="'height:'+cwheight+'vh'"></div>
			<img :src="servimag"  @click="totop()"/>
		</div>
		
    </el-row>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import numerSplit from '../components/numerSplit.vue';
import { Message } from 'element-ui';
import moment from "moment";
import lodash, { slice } from "lodash";
import ToolsUtils from '../common/toolsUtils';

export default {
    components: { numerSplit },
    data() {
        return {
			servimag:require('@/static/WechatIMG1.png'),
			cwheight:10,
            dialogAppraise: false,
			dialogAppraise2: false,
            dialogLookAppraise: false,
            startNumerIndex: 0,
            startNumerIndexRquire: false,
            appraiseText: "",
			 appraiseText2: "",
            appraiseTextRquire: false,
            calendarRange: [],
            calendarValue: new Date(),
			courseName:"",
            eduDataList: [
                {
                    id: 1,
                    name: "累计教学词汇",
                    val: "totalWordCount",
                    rate: "字"
                },
                {
                    id: 2,
                    name: "累计教学用时",
                    val: "totalHour",
                    rate: "小时"
                },
                {
                    id: 3,
                    name: "本周上课次数",
                    val: "thisWeekAttendClassCount",
                    rate: "次"
                },
                {
                    id: 4,
                    name: "本周教学词汇",
                    val: "thisWeekWordCount",
                    rate: "字"
                },
                {
                    id: 5,
                    name: "本月上课次数",
                    val: "thisMonthAttendClassCount",
                    rate: "次"
                },
                {
                    id: 6,
                    name: "本月教学词汇",
                    val: "thisMonthWordCount",
                    rate: "字"
                },

            ],

            pageNum: 1,
            pageSize: 7,
            classSalesTotal: 0,
            classSalesRecordList: [],

            planCourseList: [],
            planCourseListHistory: [],
            studentList: [], //学生列表
			isshowex:0,//是否展开
            slectedAppraise: null,
            slectedAppraiseIndex: 0,
            appraiseInfo: null,
            salesStatistic: null,
            dialogConfrimStartClass: false,
            tClassname: "",
            startclass: {
                planId: "", courseId: "", studentId: "", courseName: "",
            },
			startclass2: {
			    planId: "",
			},
            WordsSentence: {}
        }
    },
    computed: {
        ...mapState([
            'userInfos',
            'userToken',
        ]),
        ...mapGetters(["getUserToken"])
    },
	beforeDestroy(){
	  window.removeEventListener('scroll', this.handleScroll, false);
	},
    created() {
        this.initPage();
        this.getWordsSentence();
        this.getClassSaleRecordList();
        this.getPlanCourseList();
        this.getPlanCourseListAll();
        this.getStudentList();
        this.getSalesStatistic();

    },
    mounted() {
		  window.addEventListener('scroll', this.handleScroll);
		  
        this.$nextTick(() => {
            let calendarEle = document.querySelectorAll(".el-calendar-table thead th");
            console.log("calendarEle", calendarEle)
            for (let i = 0; i < calendarEle.length; i++) {
                calendarEle[i].innerHTML = '周' + calendarEle[i].innerHTML
            }
        });
		
    },
    watch: {
        calendarValue(newVal, oldVal) {
            console.log("newVal: ", moment(newVal).format('YYYY-MM-DD').valueOf());
            this.getPlanCourseList();

            if (moment(newVal).format('YYYY-MM').valueOf() != moment(oldVal).format('YYYY-MM').valueOf()) {
                this.getPlanCourseListAll();
            }

        }
    },
    methods: {
		totop(){
			 window.scrollTo({ top: 0, behavior: 'smooth' });
		},
		handleScroll(){
			 // 变量scrollTop是滚动条滚动时，距离顶部的距离
			 var scrollTop = document.documentElement.scrollTop || document.body.scrollTop
			 // // 变量windowHeight是可视区的高度
			 var windowHeight = document.documentElement.clientHeight || document.body.clientHeight
			 // // 变量scrollHeight是滚动条的总高度
			 // var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
			if(scrollTop>300)
			{
				this.servimag=require('@/static/WechatIMG1.png'),
				this.cwheight=((scrollTop-300)*0.7/5) +10;
				if(this.cwheight>=80)
				{
					this.servimag=require('@/static/WechatIMG2.png'),
					this.cwheight=80;
				}
			}else{
					this.servimag=require('@/static/WechatIMG1.png'),
				this.cwheight=10;
			}
			 
			 console.log("~~~~123~~~~~~"+scrollTop );
			  console.log("~~~~123~4~~~~~"+this.cwheight );
		},
        print(id,courseType) {
			// 课程类型  0 单词识记 1 阅读 2 自然拼读
			if(courseType==2)
			{
				this.$router.push({
				    path: "/day_print_spelling",
				    query: {
				        id: id,
				        type: 0
				    }
				}).catch(e => e)
			}else{
			this.$router.push({
			    path: "/day_print",
			    query: {
			        id: id,
			        type: 0
			    }
			}).catch(e => e)	
			}
			
         
        },
		getuserheadurl()
		{
			if (!this.userInfos.avatar||this.userInfos.avatar == "")
			{
				if (this.userInfos.role == "0") {
					//學生
					// 用户性别 （0男 1女 2未知
					if(this.userInfos.userSex==0)
					{
						return require('@/static/mr_head_1ic1.jpg')
					}else{
						return require('@/static/mr_head_1ic0.jpg')
					}
				
				} else  {
				   if(this.userInfos.userSex==0)
				   {
				   	return require('@/static/mr_head_ic1.jpg')
				   }else{
				   	return require('@/static/mr_head_ic0.jpg')
				   }
				}
			}
			return this.userInfos.avatar;
		},
		getuserheadurlitem(avatar,userSex)
		{
			if (!avatar||avatar == "")
			{
					//學生
					// 用户性别 （0男 1女 2未知
					if(userSex==0)
					{
						return require('@/static/mr_head_1ic1.jpg')
					}else{
						return require('@/static/mr_head_1ic0.jpg')
					}
			}
			return avatar;
		},
        initPage() {
            let lastDate = moment().subtract(1, 'year').format('YYYY-MM-DD').valueOf();
            let curerntDate = moment().format('YYYY-MM-DD').valueOf();
            this.calendarRange = [lastDate, curerntDate];
        },
        toHandle() {
            this.$router.push({
                path: "Detail",
                query: {
                    Id: encodeURIComponent("你好")
                }
            })
        },
        async getClassSaleRecordList() {
            let res = null;
            let apiUrl = "";
            if (this.userInfos.role == "0") {
                apiUrl = "/web/student/home/classSalesRecordList"
            } else if (this.userInfos.role) {
                apiUrl = "web/teacher/home/classSalesRecordList"
            }

            res = await this.$api.get(apiUrl, {
                headers: { //头部参数
                    frontUserToken: this.getUserToken
                },
                params: {
                    pageNum: this.pageNum,
                    pageSize: this.pageSize
                }
            })

            if (res.code == 200) {
                this.classSalesRecordList = res.rows;
                this.classSalesTotal = res.total;
            } else {
                Message({
                    type: "error",
                    message: res.msg
                })
            }

        },
        prePageClassSaleRecord() {
            if (this.pageNum == 1) {
                return;
            }
            this.pageNum--;
            this.getClassSaleRecordList();
        },
        nextPageClassSaleRecord() {
            if (this.classSalesTotal == this.classSalesRecordList.length) {
                return;
            }
            this.pageNum++;
            this.getClassSaleRecordList();
        },


        getPlanCourseList: lodash.throttle(async function () {
            let res = null;
            let apiUrl = "";
            let params = {};
            if (this.userInfos.role == "0") {
                apiUrl = "web/student/home/planCourseList"
            } else if (this.userInfos.role == "1") {
                apiUrl = "web/teacher/home/planCourseList"
                params = { classDate: moment(this.calendarValue).format("YYYY-MM-DD").valueOf() };
            }

            res = await this.$api.get(apiUrl, {
                headers: { //头部参数
                    frontUserToken: this.getUserToken
                },
                params
            })

            if (res.code == 200) {
                this.planCourseList = res.data;
            } else {
                Message({
                    type: "error",
                    message: res.msg
                })
            }
        },
            500,
            {
                leading: false,
                trailing: true,
            }
        ),
        async getStudentList() { //教师获取学生列表

            if (this.userInfos.role == "1") {

                let res = null;
                let apiUrl = "web/teacher/home/studentList";
                let params = {};
                res = await this.$api.get(apiUrl, {
                    headers: { //头部参数
                        frontUserToken: this.getUserToken
                    },
                    params
                })

                if (res.code == 200) {
                    this.studentList = res.data;
                } else {
                    Message({
                        type: "error",
                        message: res.msg
                    })
                }
            }
        },
        handleClose(done) {
            this.$confirm('确认关闭？')
                .then(_ => {
                    done();
                })
                .catch(_ => { });
        },
        changeStartNumer(index) {
            this.startNumerIndex = index + 1
        },
        getCurrentDayHasClass(day) {
            console.log(day);
            let tmp = this.planCourseListHistory.find(item => {
                let tmpDate = moment(item, "YYYY-MM-DD").format("YYYY-MM-DD").valueOf()

                if (tmpDate == day) {
                    return item;
                }
            })

            return tmp ? true : false;
        },
        getFormateDays(day) {
            let tmp = day.split('-').slice(2).join('-');
            if (tmp.startsWith("0")) {
                tmp = tmp.slice(1);
            }
            return tmp;
        },
        moreHandle() {
			this.isshowex=this.isshowex==1?0:1;
            // this.recommendList += 4;
        },
        startClassHandle(planId, courseId, studentId, courseName, studentName,classType,courseType) {
            this.startclass = {
                planId: planId, courseId: courseId, studentId: studentId, courseName: courseName,classType:classType,courseType:courseType
            };
            this.dialogConfrimStartClass = true;
            this.tClassname = studentName;
        },
		startClassHandle2(planId) {
		    this.startclass2 = {
		        planId: planId
		    };
			 this.dialogAppraise2 = true;
		},
        async startSubmit() {
			
			// this.$router.push({
			//     path: "/vocabularyTest2",
			//     query: {
			//         planId: this.startclass.planId,
			//         courseId: this.startclass.courseId,
			//         studentId: this.startclass.studentId,
			//         courseName: this.startclass.courseName,
			//         // attendClassEndTime: res.data.attendClassEndTime,
			//     }
			// });
			
            let res = await this.$api.get("/web/teacher/attendClass/startAttendClass", {
                headers: { //头部参数
                    frontUserToken: this.getUserToken
                },
                params: {
                    planId: this.startclass.planId
                }
            })
            if (res.code == 200) {
                this.$router.push({
                    path: "/vocabularyTest2",
                    query: {
                        planId: this.startclass.planId,
                        courseId: this.startclass.courseId,
                        studentId: this.startclass.studentId,
                        courseName: this.startclass.courseName,
                        attendClassEndTime: res.data.attendClassEndTime,
						classType:this.startclass.classType,
						courseType: this.startclass.courseType,
                    }
                });
            } else {
                Message({
                    type: "error",
                    message: res.msg
                })
            }
        },
        getClassTypeStr(val) {
            //0 体验课 1 30分钟课 2 60分钟课
            let tmp = "";
            if (val == 0) {
                tmp = "体验课"
            } else if (val == 1) {
                tmp = 30;
            } else if (val == 2) {
                tmp = 60;
            }
            return tmp;
        },
        queryLookAppraise(item, index) {

            if (item.status == 1) {
                this.slectedAppraise = item;
                this.slectedAppraiseIndex = index;
                this.dialogLookAppraise = true;
            } else {
                Message({
                    type: "warning",
                    message: "教师暂未评价，请耐心等待~"
                })
            }

        },
        classAppraise(item, index) {

            if (item.status == 0) {
                this.slectedAppraise = item;
                this.slectedAppraiseIndex = index;
                this.dialogAppraise = true;
            } else {
                Message({
                    type: "warning",
                    message: "教师已评价，请刷新页面~"
                })
            }
        },
        async lookAppraiseOpen() {
            if (this.userInfos.role == 0) {
                let res = await this.$api.get("web/student/home/queryAttendClassRecordEvaluate", {
                    headers: { //头部参数
                        frontUserToken: this.getUserToken
                    },
                    params: {
                        id: this.slectedAppraise.id
                    }
                })
                if (res.code == 200) {
                    this.appraiseInfo = res.data
                    if (this.appraiseInfo.amnesicWords) {
                        this.$set(this.appraiseInfo, "amnesicWords", JSON.parse(this.appraiseInfo.amnesicWords))
                    }

                } else {
                    Message({
                        type: "error",
                        message: res.msg
                    })
                }

            } else if (this.userInfos.role == 1) {
                let res = await this.$api.get("web/teacher/home/queryAttendClassRecordEvaluate", {
                    headers: { //头部参数
                        frontUserToken: this.getUserToken
                    },
                    params: {
                        id: this.slectedAppraise.id
                    }
                })
                if (res.code == 200) {
                    this.appraiseInfo = res.data
                    if (this.appraiseInfo.amnesicWords) {
                        this.$set(this.appraiseInfo, "amnesicWords", JSON.parse(this.appraiseInfo.amnesicWords))
                    }
                } else {
                    Message({
                        type: "error",
                        message: res.msg
                    })
                }

            }
        },
        lookAppraiseClosed() {
            this.slectedAppraise = null;
            this.slectedAppraiseIndex = 0;
            this.appraiseInfo = null;
        },
        getStartLevel(num) {
            let levelNum = num ? num : 0;
            let countNum = 5;
            let integerTmp = Math.floor(levelNum);
            let decimalTmp = levelNum - integerTmp;

            let imgList = [];
            for (let i = 0; i < integerTmp; i++) {
                imgList.push(require("@/static/start-level-full.png"))
            }
            if (decimalTmp > 0) {
                imgList.push(require("@/static/start-level-halfway.png"))
            }
            for (let i = 0; i < Math.floor(countNum - levelNum); i++) {
                imgList.push(require("@/static/start-level-empty.png"))
            }
            return imgList;
        },
        async getSalesStatistic() {
            if (this.userInfos.role == 1) {
                let res = await this.$api.get("web/teacher/home/salesStatistic", {
                    headers: { //头部参数
                        frontUserToken: this.getUserToken
                    },
                })
                console.log("getSalesStatistic: ", res)
                if (res.code == 200) {
                    this.salesStatistic = res.data;
                } else {
                    Message({
                        type: "error",
                        message: res.msg
                    })
                }
            }

        },
        dateFormateStr(val, format) {
            if (val) {
                return moment(val, format).format(format).valueOf();
            } else {
                return "";
            }

        },
        dialogAppraiseClosed() {
            this.$nextTick(() => {
                this.slectedAppraise = null;
                this.slectedAppraiseIndex = 0;
                this.startNumerIndexRquire = false;
                this.appraiseTextRquire = false;
                this.startNumerIndex = 0;
                this.appraiseText = "";
            })

        },
        async appraiseSubmit() {
            if (this.startNumerIndex == 0) {
                this.startNumerIndexRquire = true;
                return;
            }

            if (ToolsUtils.isStrEmpty(this.appraiseText)) {
                this.appraiseTextRquire = true;
                return;
            }

            let res = await this.$api.post("web/teacher/home/attendClassRecordEvaluateSubmit", {
                id: this.slectedAppraise.id,
                teacherEvaluate: this.appraiseText,
                teacherStar: this.startNumerIndex
            }, {
                headers: { //头部参数
                    frontUserToken: this.getUserToken
                }
            })

            if (res.code == 200) {
                Message({
                    type: "success",
                    message: "评价成功"
                })
                let tmp = { ...this.classSalesRecordList[this.slectedAppraiseIndex], ...{ status: 1 } };
                this.$set(this.classSalesRecordList, this.slectedAppraiseIndex, tmp);

                this.dialogAppraise = false;

            } else {
                Message({
                    type: "error",
                    message: res.msg
                })
            }
        },
		async cancelPlanApply() {
		    if (ToolsUtils.isStrEmpty(this.courseName)) {
		        this.startNumerIndexRquire = true;
				Message({
						type: "error",
						message: "请选择申请角色！"
				})
		        return;
		    }
		
		    if (ToolsUtils.isStrEmpty(this.appraiseText2)) {
		       Message({
		       					   type: "error",
		       					   message: "申请理由不能为空！"
		       })
		        return;
		    }
			/** 申请角色  0 学员 1 教练 */
			var applyRole=0;
			if(this.courseName='教练'){
				applyRole=1;
			}
		
		    let res = await this.$api.post("/web/teacher/attendClass/cancelPlanApply", {
		        planId: this.startclass2.planId,
		        applyRole: applyRole,
		        applyReason: this.appraiseText2
		    }, {
		        headers: { //头部参数
		            frontUserToken: this.getUserToken
		        }
		    })
		
		    if (res.code == 200) {
		        Message({
		            type: "success",
		            message: "申请成功"
		        })
		        this.dialogAppraise2 = false;
				this.getPlanCourseList();
		    } else {
		        Message({
		            type: "error",
		            message: res.msg
		        })
		    }
		
		},
        classrecod(id, courseId,courseType) {
			// 课程类型  0 单词识记 1 阅读 2 自然拼读
			if (courseType==2) {
				this.$router.push({
				    path: "/class_record2",
				    query: {
				        id: id,
				        courseId: courseId,
				    }
				});
			} else{
				this.$router.push({
				    path: "/class_record",
				    query: {
				        id: id,
				        courseId: courseId,
				    }
				});
			}
          
			
        },
        async getPlanCourseListAll() {
            if (this.userInfos.role == 1) {

                let currentTmpDate = moment(this.calendarValue, "YYYY-MM-DD").format("YYYY-MM").valueOf()

                let currentTmpDateRes = this.$api.get("web/teacher/home/planCourseDateList", {
                    headers: { //头部参数
                        frontUserToken: this.getUserToken
                    },
                    params: {
                        month: currentTmpDate
                    }
                })


                // if (res.code == 200) {
                //     this.planCourseListHistory = res.data;
                // } else {
                //     Message({
                //         type: "error",
                //         message: res.msg
                //     })
                // }

                let lastTmpDate = moment(this.calendarValue, "YYYY-MM-DD").subtract(1, "month").format("YYYY-MM").valueOf()
                let lastTmpDateRes = this.$api.get("web/teacher/home/planCourseDateList", {
                    headers: { //头部参数
                        frontUserToken: this.getUserToken
                    },
                    params: {
                        month: lastTmpDate
                    }
                })


                let nextTmpDate = moment(this.calendarValue, "YYYY-MM-DD").add(1, "month").format("YYYY-MM").valueOf()

                let nextTmpDateRes = this.$api.get("web/teacher/home/planCourseDateList", {
                    headers: { //头部参数
                        frontUserToken: this.getUserToken
                    },
                    params: {
                        month: nextTmpDate
                    }
                })

                let allRes = await Promise.all([currentTmpDateRes, lastTmpDateRes, nextTmpDateRes])

                // console.log("currentTmpDate: ", currentTmpDate)
                // console.log("lastTmpDate: ", lastTmpDate)
                // console.log("nextTmpDate: ", nextTmpDate)
                // console.log("allRes====: ", allRes)

                if (allRes) {
                    allRes.map(item => {

                        if (item.code == 200) {
                            this.planCourseListHistory = [...this.planCourseListHistory, ...item.data];
                        } else {
                            Message({
                                type: "error",
                                message: item.msg
                            })
                        }
                    })
                }
            }
        },
        async getWordsSentence() {

            let res = await this.$api.get("web/student/home/goodWordsSentence", {
                headers: { //头部参数
                    frontUserToken: this.getUserToken
                }
            })

            if (res.code == 200) {
                this.WordsSentence = res.data
            } else {
                Message({
                    type: "error",
                    message: res.msg
                })
            }

        }


    }
}
</script>

<style lang="scss" scoped>
.main-box {
    width: 100%;
    background: #E5F3F1;
    position: relative;

    .main-box-bg {
        width: 100%;
        height: 458px;
        position: absolute;
        top: 0;
        left: 0;
    }



    .title-box {
        width: 100%;
        height: 433px;
        overflow: hidden;

        .title-box-text1 {
            font-family: HelloFont WenYiHei;
            font-size: 70px;
            font-weight: normal;
            line-height: normal;
            letter-spacing: 0em;
            color: #FFFFFF;
            margin-top: 131px;
        }
    }

    .title-box-tipsbox {
        margin-top: 16px;
        width: 370px;
        height: 49px;
        border-radius: 50px;
        background: #FF783A;
        font-family: 思源黑体;
        font-size: 24px;
        font-weight: normal;
        line-height: normal;
        letter-spacing: 0em;

        font-feature-settings: "kern" on;
        /* 纯白 */
        color: #FFFFFF;
    }

    .aside-box {
        @media screen and (max-width: 768px) {
            width: 100%;
        }

    }

    .info-box {
        width: 96.666%;

        @media screen and (max-width: 768px) {
            width: 100%;
        }


        .info-box-user {

            min-height: 162px;
            padding-bottom: 10px;
            box-sizing: border-box;
            border-radius: 20px;
            background: #fff;

            .info-box-user-img {
                width: 100px;
                height: 100px;
                border: 1px solid #DEDEDE;
                box-sizing: border-box;
                border-radius: 50px;



            }

            .info-box-user-right {
                margin-left: 17px;

                .start-level-box {
                    img {
                        width: 20px;
                        height: 20px;
                        margin-right: 3px;
                    }
                }


                .info-box-user-right-name {
                    width: 170px;
                    font-family: 思源黑体;
                    font-size: 20px;
                    font-weight: normal;
                    line-height: normal;
                    letter-spacing: 0em;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    word-break: break-all;
                }

                .info-box-user-right-text1 {
                    margin-right: 24px;
                    font-family: 思源黑体;
                    font-size: 14px;
                    font-weight: normal;
                    line-height: normal;
                    letter-spacing: 0em;

                    font-feature-settings: "kern" on;
                    /* 灰 */
                    color: #ACBEB0;
                }

                .info-box-user-right-text3 {
                    margin-right: 10px;
                }

                .info-box-user-right-text2 {

                    font-family: 思源黑体;
                    font-size: 14px;
                    font-weight: normal;
                    line-height: normal;
                    letter-spacing: 0em;

                    font-feature-settings: "kern" on;
                    /* 333333 */
                    color: #333333;

                }

            }
        }
    }

    .tips-box {
        width: 96.666%;

        @media screen and (max-width: 768px) {
            width: 100%;
        }

        .tips-box-info {
            margin-top: 15px;
            min-height: 128px;
            border-radius: 20px;
            opacity: 1;

            background: #E5F7F1;

            box-sizing: border-box;
            border: 1px solid rgba(10, 162, 107, 0.2);
        }

        .tips-box-text {
            font-family: 思源黑体;
            font-size: 16px;
            font-weight: normal;
            line-height: 24px;
            letter-spacing: 0em;

            font-feature-settings: "kern" on;
            /* 绿 */
            color: #0AA26B;
            box-sizing: border-box;
        }

        .tips-box-text2 {
            font-family: 思源黑体;
            font-size: 14px;
            font-weight: normal;
            line-height: normal;
            letter-spacing: 0em;

            font-feature-settings: "kern" on;
            /* 灰 */
            color: #ACBEB0;
        }
    }

    .edu-list-box {
        margin-top: 15px;
        margin-bottom: 15px;
        width: 97.666%;

        @media screen and (max-width: 768px) {
            width: 100%;
        }


        .edu-list-box-info {
            // height: 386.5px;
            border-radius: 20px;
            // background: linear-gradient(180deg, #EDFFF8 0%, #FFFFFF 100%);

            .edu-list-box-info-img {
                width: 100%;

            }

            .edu-list-box-info-list {
                width: 100%;
                min-height: 695px;
                background: url(../static/class-bg2.png) no-repeat;
                background-size: 100% 100%;

                .edu-list-box-info-list-title {
                    margin-top: 19px;
                    margin-left: 20px;

                    img {
                        margin-right: 10px;
                        width: 24px;
                        height: 24px;
                    }

                    span {

                        font-family: Source Han Sans CN;
                        font-size: 18px;
                        font-weight: bold;
                        line-height: normal;
                        letter-spacing: 0em;

                        font-feature-settings: "kern" on;
                        /* 333333 */
                        color: #333333;
                    }
                }

                .calendar-box {
                    width: 98%;
                    margin-top: 31px;

                    .is-selected {
                        background: #EEEFFB;
                        color: #333333;
                    }

                    .has_class {
                        // background: red;
                        // border-left: 3px solid #0AA26B;
                        box-sizing: border-box;
                        // border-right: 3px solid #0AA26B;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        color: #0AA26B;
                        white-space: nowrap;
                        position: relative;

                        &::after {
                            content: " ";
                            display: inline-block;
                            background-color: rgb(243, 200, 7);
                            width: 35%;
                            height: 6px;
                            position: absolute;
                            bottom: 6px;
                            border-radius: 3px;
                        }
                    }

                }

                .edu-list-box-classlist {
                    margin-top: 20px;
                    padding: 0 25px;

                    .edu-list-box-classitem {
                        margin-bottom: 20px;
                        height: 86px;
                        box-sizing: border-box;
                        border-radius: 10px;
                        opacity: 1;

                        background: linear-gradient(301deg, #FFFFFF 35%, #E4F4EF 89%);

                        box-sizing: border-box;
                        border: 1px solid rgba(10, 162, 107, 0.2);
                        border-left: 12px solid #0AA26B;
                        box-shadow: 0px 0px 10px 0px rgba(145, 170, 158, 0.1);

                        &:last-child {
                            margin-bottom: 29px;
                        }

                        .edu-list-box-classitem-left {
                            margin-left: 17px;

                            span {
                                &:first-child {
                                    font-family: 思源黑体;

                                    font-size: 18px;
                                    font-weight: bold;
                                    line-height: normal;
                                    letter-spacing: 0em;

                                    /* 333333 */
                                    color: #333333;
                                }

                                &:last-child {
                                    margin-top: 9px;
                                    font-family: Source Han Sans CN;
                                    font-size: 14px;
                                    font-weight: normal;
                                    line-height: normal;
                                    letter-spacing: 0em;

                                    font-feature-settings: "kern" on;
                                    /* 333333 */
                                    color: #333333;
                                }
                            }

                        }

                        .edu-list-box-classitem-btn {
                            text-align: center;
                            margin-right: 18px;
                            width: 78px;
                            height: 29px;
                            border-radius: 100px;
                            opacity: 1;

                            /* 绿 */
                            background: #0AA26B;
                            font-family: Source Han Sans CN;
                            font-size: 14px;
                            font-weight: bold;
                            line-height: 29px;
                            text-align: center;
                            letter-spacing: 0em;

                            font-feature-settings: "kern" on;
                            /* 纯白 */
                            color: #FFFFFF;

                            &:hover {
                                cursor: pointer;
                            }
                        }
						       
						
						.edu-list-box-classitem-btn2 {
						    text-align: center;
							margin-top: 5px;
						    margin-right: 18px;
						    width: 78px;
						    height: 29px;
						    border-radius: 100px;
						    opacity: 1;
						
						    /* 绿 */
					
						    font-family: Source Han Sans CN;
						    font-size: 14px;
						    font-weight: bold;
						    line-height: 29px;
						    text-align: center;
						    letter-spacing: 0em;
						
							border: 1px solid #0AA26B;
						    font-feature-settings: "kern" on;
						    /* 纯白 */
						     color: #0AA26B;
						
						    &:hover {
						        cursor: pointer;
						    }
						}
						
                    }

                    .edu-list-box-classitem-grey {
                        border-left: 12px solid #666;
                    }
                }

            }


        }

        .edu-list-box-data {
            padding: 19px 20px;
            margin-top: 19px;
            height: 285px;
            border-radius: 20px;
            background: #FFFFFF;
            box-sizing: border-box;

            .edu-list-box-data-title {
                img {
                    margin-right: 8px;
                    width: 24px;
                    height: 24px;
                }

                span {

                    font-family: Source Han Sans CN;
                    font-size: 18px;
                    font-weight: bold;
                    line-height: normal;
                    letter-spacing: 0em;

                    font-feature-settings: "kern" on;
                    /* 333333 */
                    color: #333333;
                }
            }

            .edu-list-box-data-content {
                margin-top: 14px;

                .edu-list-box-data-content-item {
                    margin-bottom: 8px;

                    span {
                        margin-right: 22px;
                        font-family: 思源黑体;
                        font-size: 14px;
                        font-weight: normal;
                        line-height: 14px;
                        letter-spacing: 0em;

                        /* 333333 */
                        color: #333333;
                    }

                    .edu-list-box-data-content-item-num {
                        margin-right: 9px;
                    }

                    .edu-list-box-data-content-item-rate {
                        font-family: 思源黑体;
                        font-size: 14px;
                        font-weight: normal;
                        line-height: 14px;
                        letter-spacing: 0em;

                        /* 绿 */
                        color: #0AA26B;
                    }
                }
            }

        }
    }

    .avatar-box {
        min-height: 114px;
        border-radius: 20px;
        margin-left: 13px;
        margin-bottom: 15px;
        background: #FFFFFF;
        box-sizing: border-box;
        padding: 20px 15px 10px 14px;

        @media screen and (max-width: 768px) {
            width: 100%;
            margin-left: 0;
        }


        .avatar-box-item {
            width: 50px;
            margin-left: 10px;
            margin-bottom: 10px;

            .avatar-box-item-img {
                width: 50px;
                height: 50px;
                border-radius: 50px;
                opacity: 1;
                box-sizing: border-box;
                border: 1px solid #DEDEDE;
            }

            .avatar-box-item-img2 {
                &:hover {
                    cursor: pointer;
                }
            }

            .avatar-box-item-name {
                height: 17px;
                width: 50px;
                text-align: center;
                margin-top: 6px;

                font-family: Source Han Sans CN;
                font-size: 12px;
                font-weight: normal;
                line-height: normal;
                letter-spacing: 0em;

                font-feature-settings: "kern" on;
                /* 333333 */
                color: #333333;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                word-break: break-all;

            }

            .avatar-box-item-text {
                height: 17px;
                width: 50px;
                text-align: center;
                margin-top: 6px;

                font-family: Source Han Sans CN;
                font-size: 12px;
                font-weight: normal;
                line-height: normal;
                letter-spacing: 0em;
                white-space: nowrap;

            }
        }
    }

    .content-box {
        // width: 1195px;
        margin-left: 13px;
        margin-bottom: 15px;
        min-height: 1030;
        border-radius: 20px;
        background: #FFFFFF;
        box-sizing: border-box;
        padding: 20px 25px;

        @media screen and (max-width: 768px) {
            margin-left: 0;
        }

        .content-box-head {
            margin-bottom: 20px;

            img {
                width: 24px;
                height: 24px;
            }

            span {
                margin-left: 8px;
                font-family: 思源黑体;
                font-size: 18px;
                font-weight: bold;
                line-height: normal;
                letter-spacing: 0em;

                font-feature-settings: "kern" on;
                /* 333333 */
                color: #333333;
            }
        }

        .list-box {
            .list-box-item {
                margin-bottom: 20px;

                border-radius: 20px;
                background: #EDF4F2;
                box-sizing: border-box;
                padding: 15px 0;


                @media screen and (max-width: 1300px) {
                    flex-wrap: wrap;
                }

                .list-box-item-badge {
                    width: 100px;
                    height: 100px;
                    margin-left: 14px;
                }

                .list-box-item-left {
                    @media screen and (max-width: 1660px) {
                        width: 100%;
                    }
                }

                .list-box-item-infobox {
                    margin-left: 22px;

                    @media screen and (max-width: 1660px) {
                        margin-right: 15px;
                    }

                    .list-box-item-infobox-tipsbox {
                        @media screen and (max-width: 1660px) {}

                    }

                    .list-box-item-text1 {
                        margin-right: 15px;
                        font-family: 思源黑体;
                        font-size: 22px;
                        font-weight: bold;
                        line-height: normal;
                        letter-spacing: 0em;

                        font-feature-settings: "kern" on;
                        /* 333333 */
                        color: #333333;
                    }

                    .list-box-item-text2 {


                        @media screen and (max-width: 1660px) {
                            margin-top: 5px;
                        }

                        font-family: 思源黑体;
                        font-size: 18px;
                        font-weight: bold;
                        line-height: normal;
                        letter-spacing: 0em;

                        font-feature-settings: "kern" on;
                        /* 绿 */
                        color: #0AA26B;
                    }


                    .list-box-item-infobox-bottom {
                        margin-top: 8px;

                        .list-box-item-text3 {
                            font-family: 思源黑体;
                            font-size: 14px;
                            font-weight: normal;
                            line-height: normal;
                            letter-spacing: 0em;

                            font-feature-settings: "kern" on;
                            /* 333333 */
                            color: #333333;
                        }

                        .marginRight13 {
                            margin-right: 13px;
                        }

                    }


                }

                .list-box-btnbox {
                    margin: 15px 0;
                }

                .list-box-btn1 {
                    text-align: center;
                    line-height: 46px;
                    margin-right: 15px;
                    width: 134px;
                    height: 46px;
                    border-radius: 100px;
                    /* 绿 */
                    background: #0AA26B;
                    font-family: 思源黑体;
                    font-size: 18px;
                    font-weight: bold;
                    letter-spacing: 0em;

                    font-feature-settings: "kern" on;
                    /* 纯白 */
                    color: #FFFFFF;

                    &:hover {
                        cursor: pointer;
                    }

                }

                .list-box-btn2 {
                    text-align: center;
                    line-height: 42px;
                    margin: 0 20px 0 0;
                    width: 134px;
                    height: 46px;
                    border-radius: 100px;
                    box-sizing: border-box;
                    /* 绿 */
                    border: 2px solid #0AA26B;
                    font-family: 思源黑体;
                    font-size: 18px;
                    font-weight: bold;
                    letter-spacing: 0em;
                    font-feature-settings: "kern" on;
                    color: #0AA26B;

                    &:hover {
                        cursor: pointer;
                    }
                }

                .list-box-btn3 {
                    margin-right: 24px;
                    text-align: center;
                    line-height: 46px;
                    width: 134px;
                    height: 46px;
                    border-radius: 100px;

                    /* 灰 */
                    background: #ACBEB0;
                    font-family: 思源黑体;
                    font-size: 18px;
                    font-weight: bold;
                    text-align: center;
                    letter-spacing: 0em;

                    font-feature-settings: "kern" on;
                    /* 纯白 */
                    color: #FFFFFF;

                    &:hover {
                        cursor: pointer;
                    }

                }

                .list-box-btn4 {
                    margin-right: 22px;

                    img {
                        cursor: pointer;
                        width: 24px;
                        height: 24px;
                    }

                    img:hover {
                        width: 30px;
                        height: 30px;
                    }

                    span {
                        margin-top: 4px;
                        font-family: Source Han Sans;
                        font-size: 14px;
                        font-weight: normal;
                        line-height: normal;
                        text-align: center;
                        letter-spacing: 0em;

                        font-feature-settings: "kern" on;
                        /* 绿 */
                        color: #0AA26B;
                        white-space: nowrap;
                    }
                }

            }
        }

        .no-data {
            margin-top: 110px;
            width: 338px;
            height: 298px;
        }

        .no-data-text {
            margin-top: 7px;
            font-family: Source Han Sans;
            font-size: 20px;
            font-weight: normal;
            line-height: normal;
            text-align: center;
            letter-spacing: 0em;

            font-feature-settings: "kern" on;
            /* 333333 */
            color: #333333;
        }

    }

    .page-contorlbox {
        .page-controlbox-btn {
            text-align: center;
            line-height: 28px;
            margin: 0 10px;
            width: 88px;
            height: 30px;
            border-radius: 100px;
            opacity: 1;

            box-sizing: border-box;
            /* 灰 */
            border: 1px solid #ACBEB0;
            font-family: 思源黑体;
            font-size: 12px;
            font-weight: bold;
            letter-spacing: 0em;

            font-feature-settings: "kern" on;
            /* 333333 */
            color: #333333;
        }

        .page-controlbox-btn-disabled {
            background: #757d80;
            color: #cacaca;

            &:hover {
                cursor: no-drop;
            }
        }
    }


    .appraise-popup-title {
        width: 100%;
        height: 86px;
        border-radius: 20px 20px 0 0;
        background: #0AA26B;
        box-sizing: border-box;
        padding: 0 35px;

        .appraise-popup-title-name {
            font-family: 思源黑体;
            font-size: 26px;
            font-weight: bold;
            line-height: normal;
            letter-spacing: 0em;

            font-feature-settings: "kern" on;
            /* 纯白 */
            color: #FFFFFF;
        }

        img {
            width: 56px;
            height: 56px;
        }
    }

.appraise-popup-content2 {
        width: 100%;
        min-height: 480px;
        border-top: 1px solid transparent;
        background: #FFFFFF;
        border-radius: 0 0 20px 20px;
        box-sizing: border-box;

        .appraise-popup-content-title {
            width: 91.11%;
            margin-top: 54px;

            .appraise-popup-content-title-item {
                span {
                    &:first-child {
                        font-family: Source Han Sans CN;
                        font-size: 16px;
                        font-weight: normal;
                        line-height: 30px;
                        letter-spacing: 0em;

                        font-feature-settings: "kern" on;
                        /* 灰 */
                        color: #ACBEB0;
                    }

                    &:last-child {
                        font-family: Source Han Sans CN;
                        font-size: 16px;
                        font-weight: normal;
                        line-height: 30px;
                        letter-spacing: 0em;

                        font-feature-settings: "kern" on;
                        /* 333333 */
                        color: #333333;
                    }

                }
            }
			
			
			
        }

    }

	.textcls{
		font-size: 21px;
		font-weight: bold;
					font-variation-settings: "opsz" auto;
					font-feature-settings: "kern" on;
					/* 正文色/正文色 */
					color: #1A1A1A;
	}

    .appraise-popup-content {
        width: 100%;
        min-height: 580px;
        border-top: 1px solid transparent;
        background: #FFFFFF;
        border-radius: 0 0 20px 20px;
        box-sizing: border-box;

        .appraise-popup-content-title {
            width: 91.11%;
            margin-top: 54px;

            .appraise-popup-content-title-item {
                span {
                    &:first-child {
                        font-family: Source Han Sans CN;
                        font-size: 16px;
                        font-weight: normal;
                        line-height: 30px;
                        letter-spacing: 0em;

                        font-feature-settings: "kern" on;
                        /* 灰 */
                        color: #ACBEB0;
                    }

                    &:last-child {
                        font-family: Source Han Sans CN;
                        font-size: 16px;
                        font-weight: normal;
                        line-height: 30px;
                        letter-spacing: 0em;

                        font-feature-settings: "kern" on;
                        /* 333333 */
                        color: #333333;
                    }

                }
            }
        }

    }


    .appraise-popup-content-level {
        width: 91.11%;
        margin-top: 49px;
        box-sizing: border-box;
        position: relative;


    }

    .appraise-popup-content-level-require {
        font-size: 20px;
        color: red;
        margin-top: 20px;

    }

    .appraise-popup-content-level-name {

        font-family: Source Han Sans CN;
        font-size: 22px;
        font-weight: normal;
        line-height: 30px;
        letter-spacing: 0em;
        margin-right: 51px;
		
		font-weight: bold;
		
		font-variation-settings: "opsz" auto;
		font-feature-settings: "kern" on;
		/* 333333 */
		color: #333333;
	
        position: relative;

        .appraise-popup-content-level-badge {
            width: 12px;
            height: 12px;
            border-radius: 6px;
            /* 红 */
            background: #ED6565;
            position: absolute;
            top: 0;
            left: -15px;
        }
    }

    .appraise-popup-content-startbox {
        img {
            width: 60px;
            height: 60px;
            margin-right: 30px;

            &:hover {
                cursor: pointer;
            }

            @media screen and (max-width: 767px) {
                margin-right: 0;
            }
        }
    }


            .content-box2-select {
                width: 195px;
                height: 64px;
                border-radius: 100px;
                opacity: 1;

                // background: #E5F7F1;

                box-sizing: border-box;
                // border: 1px solid rgba(10, 162, 107, 0.2);
            }
		.appraise-popup-content-textbox-input1 {
		       
		           border-radius: 20px;
		
		           /deep/ .el-textarea__inner {
		               background: #E5F7F1;
		               font-family: 思源黑体;
		               font-size: 18px;
		               font-weight: normal;
		               line-height: normal;
		               display: flex;
		               align-items: center;
		               letter-spacing: 0em;
		
		               /* 灰 */
		               color: #ACBEB0;
		               box-sizing: border-box;
		               border: 1px solid rgba(10, 162, 107, 0.2);
		
		               @media screen and (max-width: 767px) {
		                   min-height: 100px !important;
		                   height: 100px !important;
		               }
		
		           }
		       }	
			
			
    .appraise-popup-content-textbox {
        margin-top: 52px;
        width: 91.11%;

        .appraise-popup-content-textbox-input {
            width: 100%;
            border-radius: 20px;
			margin-top: 20px;

            /deep/ .el-textarea__inner {
                background: #E5F7F1;
                font-family: 思源黑体;
                font-size: 18px;
                font-weight: normal;
                line-height: normal;
                display: flex;
                align-items: center;
                letter-spacing: 0em;

                /* 灰 */
                color: #ACBEB0;
                box-sizing: border-box;
                border: 1px solid rgba(10, 162, 107, 0.2);

                @media screen and (max-width: 767px) {
                    min-height: 100px !important;
                    height: 100px !important;
                }

            }
        }

 

        .appraise-popup-content-textbox-text {
            width: 88.11%;
            min-height: 58px;
            font-family: 思源黑体;
            font-size: 18px;
            font-weight: normal;
			white-space: pre-line;
            /* 333333 */
            color: #333333;
        }

        .appraise-popup-content-textbox-word {
            width: 88.11%;

            .appraise-popup-content-textbox-word-item {
                margin-right: 35px;
            }

            .appraise-popup-content-textbox-word-left {
                font-family: 思源黑体;
                font-size: 16px;
                font-weight: bold;
                line-height: 50px;
                letter-spacing: 0em;

                font-feature-settings: "kern" on;
                /* 绿 */
                color: #0AA26B;
                margin-right: 11px;
            }

            .appraise-popup-content-textbox-word-right {
                font-family: Source Han Sans CN;
                font-size: 16px;
                font-weight: normal;
                line-height: 50px;
                text-align: center;
                letter-spacing: 0em;

                font-feature-settings: "kern" on;
                /* 333333 */
                color: #333333;
            }

        }



    }

    .appraise-popup-content-line {
        width: 91.11%;
        margin-top: 30px;
        border: 1px solid rgba(10, 162, 107, 0.2);
    }

    .appraise-popup-footer {
        width: 91.11%;
        margin-top: 23px;
		padding-bottom: 30px;

        .appraise-popup-footer-btn1 {
            margin-right: 15px;
            text-align: center;
            line-height: 60px;
            width: 180px;
            height: 60px;
            border-radius: 100px;
            /* 灰 */
            background: #ACBEB0;
            font-family: Source Han Sans CN;
            font-size: 28px;
            font-weight: bold;
            letter-spacing: 0em;

            font-feature-settings: "kern" on;
            /* 纯白 */
            color: #FFFFFF;
        }

        .appraise-popup-footer-btn2 {
            width: 180px;
            height: 60px;
            border-radius: 100px;
            opacity: 1;

            /* 绿 */
            background: #0AA26B;

            font-family: Source Han Sans CN;
            font-size: 28px;
            font-weight: bold;
            line-height: 60px;
            text-align: center;
            letter-spacing: 0em;

            font-feature-settings: "kern" on;
            /* 纯白 */
            color: #FFFFFF;
        }


    }

    .my-calendar-box {
        width: 340px;
        height: 99.71%;
        border-radius: 8px;
    }


    /deep/ .el-dialog__header {
        border-radius: 20px 20px 0 0;
        padding: 0;

    }

    /deep/ .el-dialog__body {
        border-radius: 20px;
        padding: 0;
    }

    /deep/ .el-dialog {
        background: transparent;
        border-radius: 20px;
        box-shadow: 0 0px 0px #ccc;

        @media screen and (min-width: 992px) {
            width: 62.395%;
        }

        @media screen and (max-width: 991px) and (min-width: 768px) {
            width: 82.395%;
        }

        @media screen and (max-width: 767px) {
            width: 100%;
        }




    }

    /deep/ .el-calendar {
        background: transparent;
    }

    /deep/ .el-calendar__header {
        border: 0px;
        padding: 0 20px 2px 20px;
        flex-wrap: wrap;
    }

    /deep/ .el-calendar__body {
        padding: 12px 20px 0;
    }

    /deep/ .el-calendar__title {
        font-family: 思源黑体;
        font-size: 14px;
        font-weight: normal;
        line-height: 14px;
        letter-spacing: 0em;

        /* 333333 */
        color: #333333;
    }

    /deep/ .el-calendar-table {
        border-radius: 8px;
        background: #FFFFFF;
    }

    /deep/ .el-calendar-table tr td:first-child {
        border-left: 0px
    }

    /deep/ .el-calendar-table tr td:last-child {
        border-right: 0px
    }

    /deep/ .el-calendar-table tr:last-child {
        td {
            &:first-child {
                border-radius: 0 0 0 8px;
            }

            &:last-child {
                border-radius: 0 0 8px 0;
            }

        }

    }


    /deep/ .el-button-group {

        button {
            /* 上个月 */
            color: #FFFFFF;
            text-align: center;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            font-family: 思源黑体;
            font-size: 12px;
            font-weight: normal;
            line-height: 17px;
            letter-spacing: 0em;
            cursor: pointer;

            padding: 0;

            &:first-child {
                width: 49px;
                height: 17px;
                border-radius: 5px;
                opacity: 1;

                /* 绿 */
                background: #0AA26B
            }

            &:nth-child(2) {
                margin: 0 12px;
                width: 41px;
                height: 17px;
                border-radius: 5px;
                background: #0AA26B;
                position: relative;

                &::before {
                    content: "";
                    display: block;
                    position: absolute;
                    top: 2px;
                    left: -6px;
                    width: 1px;
                    height: 12px;
                    background-color: #B6E8D6;
                }

                &::after {
                    content: "";
                    display: block;
                    position: absolute;
                    top: 2px;
                    right: -6px;
                    width: 1px;
                    height: 12px;
                    background-color: #B6E8D6;
                }
            }

            &:last-child {
                width: 49px;
                height: 17px;
                border-radius: 5px;

                /* 绿 */
                background: #0AA26B;
            }
        }
    }

    /deep/ .el-calendar-table .el-calendar-day {
        text-align: center;
        height: 52px;
        line-height: 52px;
        padding: 0;
    }

    /deep/ .el-calendar-table thead th {
        font-family: 思源黑体;
        font-size: 12px;
        font-weight: normal;
        line-height: 14px;
        letter-spacing: 0em;

        /* 333333 */
        color: #333333;
    }


    .start-popup-content {
        background: #fff;
        border-radius: 0 0 20px 20px;
        box-sizing: border-box;
        padding: 0 52px;

        .start-popup-content-text1 {
            margin-left: 173.5px;
            margin-top: 89px;
            font-family: 思源黑体;
            font-size: 22px;
            font-weight: normal;
            line-height: 40px;
            letter-spacing: 0em;

            font-feature-settings: "kern" on;
            /* 333333 */
            color: #333333;
        }

        .start-popup-content-timebox {
            margin-top: 30px;
            margin-left: 173.5px;

            span {
                margin-right: 30px;
                font-family: 思源黑体;
                font-size: 22px;
                font-weight: normal;
                line-height: 30px;
                letter-spacing: 0em;

                font-feature-settings: "kern" on;
                /* 333333 */
                color: #333333;
            }

            div {
                width: 195px;
                height: 64px;
                border-radius: 100px;
                opacity: 1;

                background: #E5F7F1;

                box-sizing: border-box;
                border: 1px solid rgba(10, 162, 107, 0.2);
            }

        }

        .start-popup-content-tipsbox {
            margin-top: 89px;
            margin-bottom: 75px;
            font-family: 思源黑体;
            font-size: 22px;
            font-weight: normal;
            line-height: 40px;
            letter-spacing: 0em;

            font-feature-settings: "kern" on;
            /* 确认开始学员 */
            color: #333333
        }

        .start-popup-content-line {
            margin-top: 30px;
            width: 741.5px;
            height: 0px;
            opacity: 1;

            border: 1px solid rgba(10, 162, 107, 0.2);
        }

        .start-popup-content-btnsbox {
            margin-top: 31px;
            margin-bottom: 30px;

            div {
                &:first-child {
                    margin-right: 20px;
                    width: 230px;
                    height: 64px;
                    border-radius: 100px;
                    /* 灰 */
                    background: #ACBEB0;
                    font-family: 思源黑体;
                    font-size: 28px;
                    font-weight: bold;
                    line-height: 64px;
                    text-align: center;
                    letter-spacing: 0em;

                    font-feature-settings: "kern" on;
                    /* 纯白 */
                    color: #FFFFFF;
                }

                &:last-child {

                    width: 230px;
                    height: 64px;
                    border-radius: 100px;
                    /* 绿 */
                    background: #0AA26B;

                    font-family: 思源黑体;
                    font-size: 28px;
                    font-weight: bold;
                    line-height: 64px;
                    text-align: center;
                    letter-spacing: 0em;

                    font-feature-settings: "kern" on;
                    /* 纯白 */
                    color: #FFFFFF;
                }
            }
        }

    }

}

.class-no-data {
    width: 260px;
    height: 229px;
}

.class-no-data-text {
    font-size: 16px;
    color: #666;
    padding-bottom: 10px;
}

.cwdivcls{
	position: fixed;
	top: 0;
	right: 20px;
	z-index: 1000;
}
.cwdivcls img{
	cursor: pointer;
	width: 100px;
	height:141px;
	margin-top: -30px;
}
.cwdivlinecls{
	width: 6px;
	background-color:rgba(10, 162, 107,0.5);
}
 // #E6AB37
</style>
